import {Auth} from '../../../../modules/auth.js';

export const lessonSearchItemTemplate = (item, {html, components}) => {
    const {url, objectID, __position, __queryID, course_title: courseTitle, course_url: courseUrl} = item;

    const highlightedTitle = components.Highlight({
        attribute: 'title',
        hit: item,
        highlightedTagName: 'b',
    });

    return html`
        <div
                data-insights-object-id="${objectID}"
                data-insights-position="${__position}"
                data-insights-query-id="${__queryID}"
                class="searchItem searchItem--link pb-medium"
        >
            <div class="searchItem__type">Lesson</div>
            <h4 class="searchItem__heading h3 mt-none mb-small">
                <a class="searchItem__link" href="${Auth.guest() ? courseUrl : url }">
                    ${highlightedTitle}
                </a>
            </h3>
            <a href="${courseUrl}" class="link searchItem__subLink searchItem__subLink--course mt-small mb-small">${courseTitle}</a>
            <div class="searchItem__callToAction link">Read lesson</div>
        </div>
    `;
};
